import { useParams } from "react-router-dom";
import Instructors from "../instructors/Instructors";
import Assignments from "../assignments/Assignments";

export default function ClassroomAssignments() {
  const params = useParams();

  return (
    <div>
      <Assignments classroomId={params.classroomId as string} />
    </div>
  );
}
